export enum HrColor {
  LIGHT = 'light',
  NEUTRAL = 'neutral',
  DARK = 'dark',
  XDARK = 'xdark',
}
